import { useGetPresentersList } from '@/hooks';
import { PresenterUsecase } from '@d-id/types';

export const useGetPresenterByUrl = (url?: string, usecase: PresenterUsecase = PresenterUsecase.Video) => {
    const { data: presenters } = useGetPresentersList({ usecase });
    if (presenters && url) {
        const splitUrl = url.split('/');
        return presenters.find(
            presenter => presenter.url && presenter.url?.includes(splitUrl[splitUrl.length - 2]) && !presenter?.id?.includes('-removed_bg')
        );
    }
};
